<template>
  <div class="card">
    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Date de création comprise entre le</label>

          <datepicker
            v-model="filters.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>

        <div class="form-group col-sm-6">
          <label>et le</label>

          <datepicker
            v-model="filters.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-4">
          <label>Société</label>

          <v-select
            v-model="filters.merchantId"
            :options="merchantsOptions"
            :reduce="({ value }) => value"
            @input="handleMerchantChange"
          ></v-select>
        </div>

        <div class="form-group col-sm-4">
          <label>Concept</label>

          <v-select :options="conceptsOptions" v-model="filters.concept">
            <span slot="no-options">Sélectionnez une option pour Société.</span>
          </v-select>
        </div>

        <div class="form-group col-sm-4">
          <label>Menu / Statistique</label>

          <v-select
            v-model="filters.menuStats"
            :options="menuStatsOptions"
            :reduce="({ value }) => value"
          ></v-select>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <div class="row">
        <div class="col-sm-4">
          <button class="btn btn-default" @click="apply">
            <i class="icon-eye"></i>&nbsp; Visualiser
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },

  props: {
    default: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      filters: {},
      conceptsOptions: [],
    };
  },

  created() {
    this.filters = this.default;
  },

  computed: {
    ...mapState({
      concepts: (state) => state.concepts,
      merchants: (state) => state.merchants,
    }),

    ...mapGetters({
      menuStatsOptions: "getMenuStatsOptions",
    }),

    merchantsOptions() {
      return this.merchants.map((merchant) => {
        return { label: merchant.name, value: merchant.id };
      });
    },

    conceptOptions() {
      return this.concepts
        .filter((c) => {
          if (this.filters.merchantId) {
            return c.merchants?.some(
              (m) => m.merchantId === this.filters.merchantId
            );
          }
        })
        .map(({ name }) => {
          return { label: name, value: name };
        });
    },
  },

  methods: {
    apply() {
      this.$emit("update", { ...this.filters });
    },

    async handleMerchantChange() {
      if (!this.filters.merchantId) {
        this.conceptsOptions = [];
        this.filters.concept = null;
      }

      this.conceptsOptions = this.conceptOptions;
    },
  },
};
</script>
